<template>
	<div>
		<vue-good-table
			:style-class="styleClass"
			:select-options="selectOptions"
			:columns="columns"
			:rows="rows"
			:max-height="maxHeight"
			:fixed-header="fixedHeader"
			:sort-options="sortOptions"
			compact-mode
			@on-row-click="$emit('on-row-click', $event)"
		>
			<template slot="table-row" slot-scope="props">
				<span
					v-if="props.column.field == 'acoes'"
					class="edit-box"
					@click="$emit('on-row-delete', props.row)"
				>
					<feather class="edit-icon" :type="'trash-2'" size="18" />
				</span>
			</template>
		</vue-good-table>
	</div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';

export default {
	name: 'Table',
	components: {
		VueGoodTable,
	},
	props: {
		styleClass: {
			type: String,
			default: '',
		},
		selectOptions: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		columns: {
			type: Array,
			required: true,
			default: () => [],
		},
		rows: {
			type: Array,
			required: true,
			default: () => [],
		},
		sortOptions: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		compactMode: {
			type: Boolean,
			required: false,
			default: false,
		},
		maxHeight: {
			type: String,
			required: false,
			default: 'initial',
		},
		fixedHeader: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {};
	},
};
</script>

<style scoped>
.edit-box {
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
</style>

<style lang="scss">
#vgt-table {
	width: 100%;
	thead {
		font-size: 14px;
	}
	tr {
		font-size: 12px;
	}
}
</style>

